import { EligibilityCheck, FolioErrorOrder, FolioErrorPayment, Guest, Money } from '../types'
import { SalesTransferErrorPrintOrder } from '../../../redux/axios/printer/salesTransferErrors/types'
import { CANCELED_ORDER_STATUSES, RESTAURANT_ORDER_TYPE, ROOM_CHARGE_PAYMENT_METHOD } from '../constants'

const MINOR_UNITS_IN_MAJOR = 100

export const toMajor = (money?: Money): number => (money ? money.amount / MINOR_UNITS_IN_MAJOR : 0)

export const toMinor = (value: number): number => Math.round(value * MINOR_UNITS_IN_MAJOR)

export const checkEligibility = (guest: Guest, total: number): EligibilityCheck => {
	if (!guest.eligibility.roomChargesAllowed) return { ok: false, code: 'guest_not_eligible' }

	const remaining = guest.eligibility.creditRemaining
	if (remaining && toMinor(total) > remaining.amount) {
		return { ok: false, code: 'credit_limit_exceeded', remaining }
	}
	return { ok: true, remaining }
}

export const findRoomChargePayment = (order: FolioErrorOrder): FolioErrorPayment | undefined =>
	order.payments?.find(payment => payment.method === ROOM_CHARGE_PAYMENT_METHOD)

export const isCanceledOrder = (order: FolioErrorOrder): boolean =>
	CANCELED_ORDER_STATUSES.includes(order.status?.status ?? '')

export const sumFolioErrorOrders = (orders: FolioErrorOrder[]): number =>
	orders.reduce((sum, order) => isCanceledOrder(order) ? sum : sum + (order.totalPrice ?? 0), 0)

export const isRestaurantOrder = (order: FolioErrorOrder): boolean =>
	order.orderType === RESTAURANT_ORDER_TYPE

export const toSalesTransferErrorPrintOrder = (order: FolioErrorOrder): SalesTransferErrorPrintOrder => ({
	orderDayCounter: order.orderDayCounter,
	orderType: order.orderType,
	processedBy: order.processedBy,
	canceled: isCanceledOrder(order),
	totalPrice: order.totalPrice ?? 0,
})

export const getRoomChargeSignerName = (order: FolioErrorOrder): string =>
	findRoomChargePayment(order) ? order.customer?.name ?? '' : ''

export const getRoomChargeRoomNumber = (order: FolioErrorOrder): string =>
	findRoomChargePayment(order)?.roomNumber ?? ''
